import { render } from "./BarOverlineChart.vue?vue&type=template&id=f9f610d4&scoped=true"
import script from "./BarOverlineChart.vue?vue&type=script&lang=js"
export * from "./BarOverlineChart.vue?vue&type=script&lang=js"

import "./BarOverlineChart.vue?vue&type=style&index=0&id=f9f610d4&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9f610d4"]])

export default __exports__